import { useEffect } from "react";
import { Download, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

// Full-screen in-app preview of a generated report: server-rendered page images, so it looks identical on every device.
export const PdfPreview = ({ pages, name, onDownload, downloading, onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-[#040B1A]/95 backdrop-blur-md" data-testid="pdf-preview">
      <div className="flex items-center justify-between gap-3 border-b border-white/10 px-5 py-3">
        <div className="min-w-0">
          <p className="text-[10px] font-mono uppercase tracking-wider text-sky-300">PDF preview · {pages.length} page{pages.length === 1 ? "" : "s"}</p>
          <p className="truncate text-sm font-semibold text-white" data-testid="pdf-preview-name">{name}</p>
        </div>
        <div className="flex items-center gap-2">
          <Button type="button" onClick={onDownload} disabled={downloading} className="rounded-full bg-sky-400 text-[#061C40] font-bold hover:bg-sky-300" data-testid="pdf-preview-download">{downloading ? <Loader2 size={15} className="mr-2 animate-spin" /> : <Download size={15} className="mr-2" />} Download</Button>
          <Button type="button" onClick={onClose} variant="outline" className="rounded-full border-white/15 bg-transparent hover:bg-white/10" data-testid="pdf-preview-close"><X size={15} className="mr-2" /> Close</Button>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto px-3 py-5 sm:px-6" data-testid="pdf-preview-pages">
        <div className="mx-auto flex max-w-[860px] flex-col gap-6">
          {pages.map((src, i) => <img key={i} src={src} alt={`Page ${i + 1}`} className="w-full rounded-lg shadow-2xl shadow-black/60 ring-1 ring-white/10" data-testid={`pdf-preview-page-${i + 1}`} />)}
        </div>
      </div>
    </div>
  );
};
